// Carousel initializations — runs deferred, DOM already parsed
(function () {
  document.querySelectorAll('.slideshow').forEach(function (el) {
    new LiteSlider(el, {
      slidesToShow: 2,
      slidesToScroll: 2,
      autoplay: false,
      infinite: false,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 749,  settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    });
  });

  document.querySelectorAll('.brands_slider').forEach(function (el) {
    new LiteSlider(el, {
      slidesToShow: 6,
      slidesToScroll: 3,
      autoplay: false,
      infinite: false,
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 2 } },
        { breakpoint: 750,  settings: { slidesToShow: 2, slidesToScroll: 2 } }
      ]
    });
  });

  document.querySelectorAll('.testimonials').forEach(function (el) {
    new LiteSlider(el, {
      slidesToShow: 2,
      slidesToScroll: 2,
      autoplay: true,
      autoplaySpeed: 4000,
      infinite: false,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 600,  settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 480,  settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    });
  });
}());
